// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"4f0fdc99","453":"d78094d8"}[chunkId] + ".chunk.js";
};